// cart-delivery.js
$(document).ready(function () {
  if ($("body.template-cart").length > 0) {
    //swtich to handle AB testing

    

  // if (window.location.hash) { 
  //   if(!localStorage.getItem('ab-cart-test')) { 
  //     localStorage.setItem('ab-cart-test', window.location.hash);
  //   }
  // }

  // if (localStorage.getItem('ab-cart-test')) { 
  //   window.location.hash = localStorage.getItem('ab-cart-test');
  // }
 
  // function applyHashCss(hash) {

  //   var param = hash || window.location.hash; 

  //   switch (param) {
  //     case "#freeshipping":
  //       $(".free-delivery-container").addClass("display");
  //       break;
  //     case "#checkoutnow":
  //       $(".next-day-incentive").addClass("display");
  //       break;
  //     case "#new":
  //       $(".free-delivery-container, .next-day-incentive").addClass("display");
  //       break;
  //   }

  // }

  // applyHashCss(localStorage.getItem('ab-cart-test'));

  

    // if ($("#next-day-incentive-non-fresh").length > 0) {

    //   var midday = new Date().setHours(12, 0, 0, 0, 0);

    //   var time = setInterval(function () {
    //     // Get today's date and time
    //     var now = new Date().getTime();

    //     var distance = midday - now;
    //     var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    //     var hours = Math.floor(
    //       (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    //     );
    //     var minutes = Math.floor(
    //       (distance % (1000 * 60 * 60)) / (1000 * 60)
    //     );
    //     var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    //     $("#next-day-countdown-non-fresh").text(
    //       hours + "h : " + minutes + "m"
          
    //     );
    //     // If the count down is over, write some text
    //     if (distance < 0) {
    //       clearInterval(time);
    //       $("#next-day-incentive-non-fresh").hide();
    //     }
    //   }, 1000);

    // }

    var postData = JSON.parse(
      '{"myShopifyDomain":"planet-organic-uk.myshopify.com"}'
    );
    var deliveryJson;

    // not required until store pick up is being used.
    var typeOfShipment = $("#order-slots-option input:checked").val();

    $("#checkOutButton").on("click", function (e) {
      if ($("#order-slots").length) {
        if ($("#order-slots-date option:selected").prop("disabled")) {
          e.preventDefault();
          $("#dateNotSelected").addClass("selected");
        }
      }
    });

    $.post(
      "https://slots-app.logbase.io/api/slots",
      postData,
      function (data) {

        
        deliveryJson = data.slots;
        deliveryJson.forEach(function (slot) {
          if (slot.type === "delivery") {
            $("#order-slots-date").append(
              '<option value="' + slot.date + '">' + slot.date + "</value>"
            );
          }
        });

        $("#order-slots-date").val($("#order-slots-date option:first").val());
        $("#order-slots-date").trigger("change");

        // if ($("#next-day-incentive-fresh").length > 0) {

        //   var firstAvailableDate = deliveryJson[0].date;
        //   var midday = new Date().setHours(24, 0, 0, 0, 0);
        //   var x = setInterval(function () {
        //     // Get today's date and time
        //     var now = new Date().getTime();

        //     var distance = midday - now;
        //     var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        //     var hours = Math.floor(
        //       (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        //     );
        //     var minutes = Math.floor(
        //       (distance % (1000 * 60 * 60)) / (1000 * 60)
        //     );
        //     var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        //     $("#next-day-countdown-fresh").text(
        //       hours + "h : " + minutes + "m"
        //     );
        //     // If the count down is over, write some text
        //     if (distance < 0) {
        //       clearInterval(x);
        //       $("#next-day-countdown-fresh").hide();
        //     }
        //   }, 1000);

        //   $("#next-available-day-fresh").append(firstAvailableDate);
        // }
      },
      "json"
    ).done(function () {
      $("#order-slots-date").attr("disabled", false);
      $("#order-slots-time").attr("disabled", false);
    });

    $("#order-slots-date").on("change", function (event) {
      var current = $(this).val();
      $("#order-delivery-date").val(current);
      $("#order-delivery-date-email").val(current);
      var timeArray;
      deliveryJson.forEach(function (item) {
        if (current === item.date) {
          timeArray = item.timeSlots;
        }
      });
      populateTimeSlots(timeArray);
    });

    $("#order-slots-time").on("change", function () {
      $("#order-delivery-time").val($(this).val());
    });

    // this wil pass in one array of
    function populateTimeSlots(timeSlots) {
      if ((timeSlots.length = 1)) {
        $("#order-slots-time").addClass("oneTimeSlot");
      }

      $("#order-slots-time").find("option").remove();
      timeSlots.forEach(function (slot) {
        $("#order-slots-time").append(
          '<option value="' + slot + '">' + slot + "</option>"
        );
        $("#order-slots-time").trigger("change");
      });
    }
  }
});

// cart-deliverydate.js
$(document).ready(function () {
  $("#order-slots-date, #order-slots-time").on("change", function (event) {
  var date = $('#order-slots-date').val();
  var time = $('#order-slots-time').val();

  const dateTime = {
    devliveryDate: date,
    deliveryTime: time,
  }
  setCookie("zapietDeliveryDate", formatDate(date), 1); 
    localStorage.setItem('deliveryDate', JSON.stringify(dateTime))
  });
$('.qty-adjuster__remove').on("click", function (event) {
  localStorage.removeItem('deliveryDate');
});
});

function setCookie(cname, cvalue, exhours) {
var d = new Date();
d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
var expires = "expires="+d.toUTCString();
document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function formatDate(date) {
var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('/');
}

// cart.drawer.js
$(document).ready(function () {

	$(".current-cart").on("click", function(){
		//$('body').addClass('cart-closed');
	  	// $(".current-cart").addClass('disable');

		//console.log('cart closed true');
		if ($("body").hasClass("show-cart-summary")) {
			localStorage.setItem('cartClosed', false);
		} else{
			localStorage.setItem('cartClosed', true);
 
		}
	})
	
	//if(localStorage.getItem('cartClosed', true)) {
		// $('body').addClass('cart-closed');
		// $(".current-cart").addClass('disable');
	//} else {
		// $('body').removeClass('cart-closed');
	//}
	// if ($("body").hasClass("cart-closed")) {
	// 	$(".current-cart").on("click", function(){
	// 		$('body').removeClass('cart-closed');
	// 		// $(".current-cart").removeClass('disable');
	// 		localStorage.removeItem('cartClosed');
	// 	})
	// }

});

// zapiet-script.js
// $(document).ready(function(){
// 	function getCookie(name) {
// 	    var dc = document.cookie;
// 	    var prefix = name + "=";
// 	    var begin = dc.indexOf("; " + prefix);
// 	    if (begin == -1) {
// 	        begin = dc.indexOf(prefix);
// 	        if (begin != 0) return null;
// 	    }
// 	    else
// 	    {
// 	        begin += 2;
// 	        var end = document.cookie.indexOf(";", begin);
// 	        if (end == -1) {
// 	        end = dc.length;
// 	        }
// 	    }
// 	    // because unescape has been deprecated, replaced with decodeURI
// 	    //return unescape(dc.substring(begin + prefix.length, end));
// 	    return decodeURI(dc.substring(begin + prefix.length, end));
// 	} 
// 	var cartUpdated = getCookie("freshCart");
// 	if (cartUpdated == null) {
// 	 	//no cookie
// 		$( ".checkout-button" ).click(function() {
// 			const attributes = {
// 			      'Pickup-Location-Id': '',
// 			      'Pickup-Date': '',
// 			      'Pickup-Time': '',
// 			      'Delivery-Location-Id': '',
// 			      'Delivery-Date': '',
// 			      'Delivery-Time': '',
// 			      'Shipping-Date': '',
// 			      'Shipping-Time': '',
// 			      'Custom-Attribute-1': '',
// 			      'Custom_attribute_2': '',
// 			      'Custom-Attribute-3': '',
// 			      'Pickup-Location-Company': '',
// 			      'Pickup-Location-Address-Line-1': '',
// 			      'Pickup-Location-Address-Line-2': '',
// 			      'Pickup-Location-City': '',
// 			      'Pickup-Location-Region': '',
// 			      'Pickup-Location-Postal-Code': '',
// 			      'Pickup-Location-Country': '',
// 			      'Delivery-Slot-Id': '',
// 			      'Checkout-Method': '',
// 			      'Custom-Attribute-1': '',
// 			      'Custom-Attribute-2': '',
// 			      'Custom-Attribute-3': ''
// 			};$.post('/cart/update.js', {
// 			      attributes: attributes
// 			}, function(shopping_cart) {        
// 			      console.log('no cookies')
// 			}, 'json');
// 		});
// 	}
// })
$( ".ClearAttrBtn" ).click(function() {
	const attributes = {
	      'Pickup-Location-Id': '',
	      'Pickup-Date': '',
	      'Pickup-Time': '',
	      'Delivery-Location-Id': '',
	      'Delivery-Date': '',
	      'Delivery-Time': '',
	      'Shipping-Date': '',
	      'Shipping-Time': '',
	      'Custom-Attribute-1': '',
	      'Custom_attribute_2': '',
	      'Custom-Attribute-3': '',
	      'Pickup-Location-Company': '',
	      'Pickup-Location-Address-Line-1': '',
	      'Pickup-Location-Address-Line-2': '',
	      'Pickup-Location-City': '',
	      'Pickup-Location-Region': '',
	      'Pickup-Location-Postal-Code': '',
	      'Pickup-Location-Country': '',
	      'Delivery-Slot-Id': '',
	      'Checkout-Method': '',
	      'Custom-Attribute-1': '',
	      'Custom-Attribute-2': '',
	      'Custom-Attribute-3': ''
	};$.post('/cart/update.js', {
	      attributes: attributes
	}, function(shopping_cart) {        
	      console.log('done')
	}, 'json');
});
